import React from 'react'
import Box from '@mui/material/Box'

type Props = {
  color?: React.CSSProperties['borderColor']
}

const EventDot: React.FC<Props> = ({ color }) => {
  return (
    <Box
      sx={{
        border: "4px solid",
        flexShrink: 0,
        borderColor: {color},
        borderRadius: "4px",
        boxSizing: "content-box",
        margin: "0px 4px",
      }}
    />
  )
}

export default EventDot
